import { createStyles } from 'antd-style'

import { formatDateTime } from '@eastcoal/common/utils/date'

import { EaDatabaseIcon } from '@eastcoal/icon/EaDatabaseIcon'

import { FloorBlock } from '../../../components/FloorBlock'

import { DataDashboard } from './Data'
import { OrderList } from './Order'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: `minmax(0,1fr) ${token.paddingXL}px minmax(0,1fr)`
  },
  divider: {
    width: 1,
    height: '50%',
    alignSelf: 'end',
    marginBlockEnd: token.marginMD,
    backgroundColor: token.colorSplit
  },
  extra: {
    color: token.colorTextTertiary
  }
}))

export const TradeStatisticFloor = () => {
  const { styles } = useStyles()

  return (
    <FloorBlock
      icon={<EaDatabaseIcon />}
      title='交易数据'
      classNames={{
        body: styles.container
      }}
      extra={
        <span className={styles.extra}>
          更新时间：{formatDateTime(new Date())}
        </span>
      }
    >
      <DataDashboard />
      <div className={styles.divider} />
      <OrderList />
    </FloorBlock>
  )
}
